import { render, staticRenderFns } from "./TeachUnit.vue?vue&type=template&id=2b76a87e&scoped=true"
import script from "./TeachUnit.vue?vue&type=script&lang=js"
export * from "./TeachUnit.vue?vue&type=script&lang=js"
import style0 from "./TeachUnit.vue?vue&type=style&index=0&id=2b76a87e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76a87e",
  null
  
)

export default component.exports